import React from 'react'
import { useState } from 'react'
import { useKaipiaodanSCMutation } from '../../store/DianShangYeWuApi'
import Icon from '../../cpn/Icon'
import { Modal, App, Form } from 'antd'
import UploadPic from '../../cpn/UploadPic'
function InvoiceUpload(props) {
    const { message } = App.useApp();
    const [open, setOpen] = useState(false)
    const [info, setInfo] = useState({
        kpsq_id: props.kpsq_id,
        kpsq_fp_file: '',
        kpsq_fp_name: ''
    })
    const [sc] = useKaipiaodanSCMutation()
    return (
        <>
            <Icon type='upload' onClick={() => {
                if(props.kpsq_state !== '5' && props.kpsq_state !== '6') {
                    message.error('开票申请未完成，不能上传发票')
                    return
                }
                setOpen(true)
            }} />
            <Modal 
                open={open} 
                title='上传发票'
                onCancel={() => {
                    setOpen(false)
                }}
                onOk={() => {
                    sc(info).then((res) => {
                        if (res.data.Status === 'success') {
                            message.success('上传成功')
                            setOpen(false)
                        }
                        if (res.data.Status === 'fail') {
                            message.error('上传失败'+res.data.Message)
                        }
                    })
                }}
            >
                <Form>
                    <UploadPic
                        name='kpsq_image'
                        onChange={(e,f) => {
                            setInfo(prevState => ({ ...prevState, kpsq_fp_file: e, kpsq_fp_name: f }))
                        }}
                        maxCount={5}
                        style={{ width: '100%' }}
                        formStyle={{marginBottom: 0,width: '100%'}}
                    />
                </Form>
            </Modal>
        </>
    )
}

export default InvoiceUpload